<template>
  <div class="auth-form">
    <b-tabs content-class="mt-3" fill pills>
      <b-tab title="Вхід" active>
        <auth-form-login />
      </b-tab>
      <b-tab title="Реєстрація">
        <auth-form-register />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import AuthFormLogin from "./auth-form-login.vue";
import AuthFormRegister from "./auth-form-register.vue";
export default {
  components: {
    AuthFormLogin,
    AuthFormRegister,
  },
};
</script>

<style lang="scss" scoped>
.auth-form {
}
</style>
